<script lang="ts">
	import Breadcrumb from '../../../components/Breadcrumb.svelte';
	import { onMount } from 'svelte';
	import { detectClickOutside } from '$lib/utils/detectClickOutside';
	export let data: any;
	import arrow from '$lib/images/volba-skutru/arrow.png';
	import cn from 'classnames';
	import ScooterSelectorNavigation from '../../(components)/ScooterSelectorNavigation.svelte';
	let showList = false;

	let filtered: any;
	let filterText = '';

	let elm: any;

	onMount(function () {
		elm.focus();
		showList = true;
	});

	filtered = data.data;
	function filterProducer() {
		showList = true;
		if (filterText == '' || filterText == undefined) {
			filtered = data.data;
			return;
		} else {
			//data filter is not a function
			// 
			// get only INT from string remove all text
			var ccm = filterText.replace(/\D/g, '');
			filtered = filterByCcm(data.data, parseInt(ccm));
		}
	}

	const filterByCcm = (arr: [], ccmValue: number): any[] => {
		if (!Array.isArray(arr)) {
			throw new Error("Input is not an array");
		}
		
		// contains ... 10 means 100 too
		return arr.filter(item => item.ccm.toString().includes(ccmValue.toString()));
	};

	const handleClickOutside = () => {
		showList = false;
	};

	const cls = 'flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-bold';
</script>

<svelte:head>
	<title>Skútry {data.slug.charAt(0).toUpperCase() + data.slug.slice(1)}</title>
	<meta name="description" content="Vyberte model skútru od výrobce {data.slug.charAt(0).toUpperCase() + data.slug.slice(1)} a objevte nabídku dílů a technické údaje"/>
	<link rel="canonical" href={`https://www.scootland.cz/skutry/${data.slug}/`} />
	<meta property="og:title" content="Skútry {data.slug.charAt(0).toUpperCase() + data.slug.slice(1)}" />
	<meta property="og:description" content="Vyberte model skútru od výrobce {data.slug.charAt(0).toUpperCase() + data.slug.slice(1)} a objevte nabídku dílů a technické údaje"/>
	<meta property="og:image" content="/image/og-skutry.webp"/>
	<meta property="og:url" content="https://www.scootland.cz/skutry/{data.slug}/"/>
	<meta property="og:suite_name" content="Scootland"/>
	<meta property="og:type" content="website" />
</svelte:head>


<Breadcrumb
	breadcrumbs={[
		{ name: 'Skútry', link: '/skutry' },
		{ name: data.slug.charAt(0).toUpperCase() + data.slug.slice(1), link: data.slug }
	]}
/>

<section class="bg-graybg py-8">
	<div class="mx-auto w-full px-2 md:w-4/6 lg:px-0">
		<div class="container mx-auto">
			<div class="border-b border-gray-200">
				<h1 class="mb-6 pb-4 text-center text-2xl font-bold sm:text-3xl">
					Skútry {data.slug.charAt(0).toUpperCase() + data.slug.slice(1)}
				</h1>
			</div>
		</div>

		<ScooterSelectorNavigation producer={data.slug.charAt(0).toUpperCase() + data.slug.slice(1)} step={1} />

		<div class="relative z-10 flex w-full">
			<div class="w-1/2 pr-2 md:pr-2">
				<div class="relative">
					<input
						bind:this={elm}
						bind:value={filterText}
						class="form-select px-4.5 border-primary focus:border-blue-600 m-0 block w-full appearance-none border-4 border-solid bg-white bg-clip-padding bg-no-repeat py-3.5 text-left indent-8 text-gray-700 transition ease-in-out focus:bg-white focus:text-gray-700 focus:outline-none"
						focused
						use:detectClickOutside
						on:click_outside={handleClickOutside}
						on:click={() => (showList = true)}
						on:input={filterProducer}
						placeholder="Objem ccm"
						type="text"
					/>
					<div
						data-test="producers_list"
						class="{showList ? '' : 'hidden'} test focus:border-focusblue absolute w-full
       overflow-y-auto border-4 bg-white bg-clip-padding bg-no-repeat text-gray-700
      transition ease-in-out focus:bg-white focus:text-gray-700 focus:outline-none"
					>
						{#if filtered !== null}
							{#each filtered as item}
								<a
									id={item.ccm}
									href="/skutry/{data.slug}/{item.ccm}/"
									class="w-100 flex cursor-pointer p-2 pl-5 transition hover:bg-gray-100"
								>
									{#if item.ccm == 0}
										Elektro
									{:else}
										{item.ccm} ccm
									{/if}
								</a>
							{/each}
						{/if}
					</div>
				</div>
			</div>
			<div class="w-1/2 pl-4 md:pl-2">
				<div class="relative">
					<select
						disabled
						class="m-auto form-select px-4.5 focus:border-blue-600 m-0 block w-full appearance-none 
						border-4 border-solid border-gray-300 bg-gray-300 bg-clip-padding bg-no-repeat py-3.5 
						indent-8 text-gray-700 transition ease-in-out focus:bg-white focus:text-gray-700 
						focus:outline-none"
					>
						<option selected>Typ skútru</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="shadow-top bg-white pt-16">
	<h2 class="mb-6 px-5 pb-4 text-center text-xl font-bold">
		Nepamatujete si váš model {data.slug}? Zkuste to podle obrázku níže!
		<img src={arrow} class="ml-2 inline-block" alt="šipka na výběr skútru" />
	</h2>
	<div class="container mx-auto border-b border-gray-200 px-5 pb-16">
		<div class="grid grid-cols-2 gap-x-4 gap-y-8 sm:gap-x-8 md:grid-cols-3 lg:grid-cols-4">
			{#if data.scooters}
				{#each data?.scooters as scooter}
					<a class="border-b border-gray-200 text-center text-gray-500"
					   title="Jdi na detail skútru {scooter.producer} {scooter.name} {scooter.ccm} ccm pro náhradní díly, technické údaje, rady a tipy"
					   href="/skutr-{scooter.url}/">
						<div class="relative aspect-square w-full grow-0 bg-gray-100 p-3 sm:p-5">
							<img
								class="w-full rounded object-cover object-center"
								src={scooter.main_image_new.url_medium}
								alt={scooter.main_image_new.alt}
							/>
						</div>
						<h2 class="mt-4 text-xl font-bold">
							{scooter.name}
						</h2>
						<h2 class="font-lg mb-4">
							{scooter.ccm !== "0" ? scooter.ccm + " ccm": "elektro"}
						</h2>
					</a>
				{/each}
			{/if}
		</div>
	</div>
</section>
